import {PhoneNumber, Alpha3CountryCode, Country} from 'platform/components';
import {Nullish} from 'utility-types';

import {find, isNil} from 'ramda';

export const getPhoneNumber = (
  prefix: string | Nullish,
  number: string | Nullish,
  countries?: Country[]
) => {
  const emptyPhoneNumber = {
    prefix: countries?.[0]?.dialCode,
    number: number ?? undefined,
    countryCode: countries?.[0]?.countryCode,
  };

  if (isNil(prefix) || isNil(number)) {
    return emptyPhoneNumber;
  }

  const phoneItem = find((item) => item.dialCode === prefix, countries ?? []);

  if (!phoneItem) {
    return emptyPhoneNumber;
  }

  const countryCode = phoneItem.countryCode as Alpha3CountryCode;

  const phoneNumber: PhoneNumber = {
    prefix,
    number,
    countryCode,
  };

  return phoneNumber;
};
